import React, {useEffect, useState} from 'react';
import { Container, Group, rem, ScrollArea, Tabs, TextInput } from '@mantine/core';
import {useNavigate} from "react-router";
import {PinnedTab} from "@repo/services";
import {useLocalStorage} from "@mantine/hooks";
import {IconTrash, IconEdit, IconX} from '@tabler/icons-react';
import {errorBoundaryWrapper} from "@repo/utils";
import { useThemeContext } from '../../theme/ThemeContext';

const PinnedTabsFooter = () => {
    const navigate = useNavigate();
    const { theme } = useThemeContext();
    const pinnedTabsAttributeName = 'pinned-tabs';
    const iconStyle = { height: rem(20), width: rem(20)};

    const [pinnedTabs, setPinnedTabs] = useLocalStorage<PinnedTab[]>({
        key: pinnedTabsAttributeName,
        defaultValue: []
    });

    const [editTabRoutes, setEditTabRoutes] = useState<string[]>([]);
    //TODO: Set isEdit for individual tab, not whole footer

    const deleteTab = (route:string) => {
        const updatedTabs = pinnedTabs.filter((tab) => tab.route !== route);
        setPinnedTabs(updatedTabs);
    }

    const editTabName = (val:string, route:string) => {
        const tabs = [...pinnedTabs]
        const tab = tabs?.find((tab) => tab.route === route);
        const tabIndex = tabs?.indexOf(tab as PinnedTab);

        if (tabIndex !== -1) {
            tabs[tabIndex].name = val;
        } else {
            console.error(`Tab with route "${route}" not found.`);
        }

        setPinnedTabs(tabs);
    }

    return (
      <ScrollArea h={pinnedTabs.length === 0 ? 0: 60} scrollbars="x">
          <Container p={10} size='responsive' style={{maxHeight: 55}} h={60}>
            <Tabs variant="outline" defaultValue="gallery">
                <Tabs.List>
                    {pinnedTabs?.map((tab, i) => {
                        return (
                            <Tabs.Tab key={i} bg={theme.cardColor} value={i?.toString() || ''} onClick={() => navigate(tab.route)} style={{ border: '1px solid black'}}>
                                {/*<Tabs.Tab key={i} value="gallery" leftSection={<IconPhoto style={iconStyle} />}>*/}
                                <Group justify='space-between' gap='lg'>
                                    {!editTabRoutes.includes(tab.route) && (
                                        <div>
                                            {tab.name}
                                        </div>
                                    )}
                                    {editTabRoutes.includes(tab.route) && (
                                        <TextInput
                                            size="xs"
                                            value={tab.name}
                                            onChange={(e) => editTabName(e.target.value, tab.route)}
                                        />
                                    )}
                                    <Group justify='flex-end' gap='xs'>
                                        {!editTabRoutes.includes(tab.route) && (
                                            <IconEdit color='green' style={iconStyle} onClick={() => {
                                                const editTabs = [...editTabRoutes];
                                                editTabs.push(tab.route);
                                                setEditTabRoutes(editTabs);
                                            }} />
                                        )}
                                        {editTabRoutes.includes(tab.route) && (
                                            <IconX color='green' style={iconStyle} onClick={() => {
                                                const editTabs = [...editTabRoutes];
                                                const item = editTabs.find((t) => t === tab.route);
                                                const index = editTabs?.indexOf(item as string);
                                                if (index !== -1) editTabs.splice(index, 1);
                                                setEditTabRoutes(editTabs);
                                            }} />
                                        )}
                                            <IconTrash onClick={() => deleteTab(tab.route)} color='gray' style={iconStyle} />
                                    </Group>
                                </Group>
                            </Tabs.Tab>
                        )
                    })}
                </Tabs.List>
            </Tabs>
        </Container>
      </ScrollArea>
    );
};

export default errorBoundaryWrapper(PinnedTabsFooter);
